import { render, staticRenderFns } from "./AppSignupInputPage.vue?vue&type=template&id=cfd8583e"
import script from "./AppSignupInputPage.vue?vue&type=script&lang=ts"
export * from "./AppSignupInputPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports